exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  background: #F1F1F1;\n  font-family: \"Roboto\", sans-serif; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/containers/App/app.scss
// module id = 373
// module chunks = 0